import { useState, useEffect } from 'react';
import { api } from './lib/api';
import { Header } from './components/layout/Header';
import { StatsGrid } from './components/layout/StatsGrid';
import { Filters } from './components/filters/Filters';
import { TweetsList } from './components/tweets/TweetsList';
import { LoginModal } from './components/LoginModal';
import { useStats } from './hooks/useStats';
import { useTweets } from './hooks/useTweets';
import { Layout } from './components/layout/Layout';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Always call hooks - only use data when authenticated
  const { stats, loading: statsLoading } = useStats();
  const tweetsData = useTweets();

  useEffect(() => {
    // Check if token exists and is valid
    const checkAuth = async () => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        try {
          const data = await api.verifyToken();
          if (data.valid) {
            setIsAuthenticated(true);
          } else {
            localStorage.removeItem('auth_token');
            setShowLogin(true);
          }
        } catch {
          localStorage.removeItem('auth_token');
          setShowLogin(true);
        }
      } else {
        setShowLogin(true);
      }
      setIsChecking(false);
    };

    checkAuth();
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-text-secondary">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-primary">
        <LoginModal
          isOpen={showLogin}
          onLoginSuccess={handleLoginSuccess}
        />
      </div>
    );
  }

  return (
    <Layout>
      <Header />
      <StatsGrid stats={stats?.overview ?? null} loading={statsLoading} />
      <div className="grid md:grid-cols-[280px_1fr] gap-5 items-start">
        <Filters {...tweetsData} />
        <TweetsList {...tweetsData} />
      </div>
    </Layout>
  );
}

export default App;
